import { SettingConst } from '@faire/web-api--source/types';

/**
 * Experiment setting for enabling Decagon AI chatbot for brands in the Help Center
 */
export const HELP_CENTER_BRAND_AI_CHATBOT_241209 =
  'HELP_CENTER_BRAND_AI_CHATBOT_241209' as SettingConst<
    'HELP_CENTER_BRAND_AI_CHATBOT_241209',
    boolean,
    'HELP_CENTER'
  >;
